<template>
<calendar
  v-model="inputValue"
  v-bind="$props"
  @keyup="onKeyup"
  @blur="onBlur"
></calendar>
</template>

<script>
import Vue from 'vue'
import Calendar from '@/components/Calendar'
import { calendarDefaults } from '@/consts/calendar'

export default {
  name: 'my-calendar',
  props: {
    value: {
      type: [String, Date]
    },
    format: {
      type: String,
      default: calendarDefaults.format
    },
    inputClassObj: {
      type: Object,
    },
    inputClearButton: {
      type: Boolean,
      default: calendarDefaults.inputClearButton
    },
    clearButton2Disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: calendarDefaults.readonly
    },
    disabled: {
      type: Boolean,
      default: calendarDefaults.disabled
    },
    placeholder: {
      type: String
    },
    lang: {
      type: String,
      default: calendarDefaults.lang
    },
    pane: {
      type: Number,
      default: calendarDefaults.pane
    },
    dayHeaderFormat: {
      type: String,
      default: calendarDefaults.dayHeaderFormat
    },
    disableSwitchMonthView: {
      type: Boolean,
      default: calendarDefaults.disableSwitchMonthView
    },
    onDayClick: {
      type: Function,
      default() {}
    },
    changePane: {
      type: Function,
      default() {}
    },
    rangeBus: {
      type: Function,
      default() {
        // return new Vue()
      }
    },
    dateInputBgColor: {
      type: String,
    },
    setDateValueOnce: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    value() {
      this.trySetDateValue()
    },
  },
  data() {
    return {
      isDateValueSet: false,
      dateValue_: null,
      givenTextValue_: '',
      calendarDefaults: calendarDefaults,
    }
  },
  computed: {
    inputValue: {
      get() {
        if (!this.dateValue_) { return '' }
        return Vue.filter('dtFormat')(new Date(this.dateValue_), this.format)
      },
      set(val) {
        // 一応textの状態も保持するだけしておこう
        this.givenTextValue_ = val
        let dt = Vue.filter('ensureDate')(val)
        dt = isNaN(dt) ? null : dt
        if (dt && (val && val.length === this.format.length)) {
          // 桁数が正常かつdtが正常なら、その時点で同期しておく
          this.dateValue_ = dt
        }
        this.$emit('date-input', dt)
        // emit for vee-validate flags to be updated
        this.$emit('input', dt)
      },
    },
  },
  mounted() {
    this.trySetDateValue()
  },
  methods: {
    trySetDateValue() {
      if (!this.value) { return }
      if (this.setDateValueOnce && this.isDateValueSet) { return }
      this.isDateValueSet = true
      this.dateValue_ = this.value
    },
    onKeyup($event) {
      this.$emit('keyup', $event)
    },
    onBlur($event) {
      // emit for vee-validate flags to be updated
      this.$emit('blur', $event)
    },
  },
  components: { Calendar }
}
</script>
